import { Server } from '../../../shared/models/server.models';
import { SystemUser } from '../../../shared/models/system-users.models';
import { Website } from '../../../shared/models/website.models';

export interface OriginVhostAlias {
  id: number;
  alias: string;
}

export interface OriginVhostPHPModule {
  id: number;
  name: string;
}

export interface OriginVhostPHPConfigParameter {
  id: number;
  name: string;
}

export interface OriginVhostPHPConfig {
  id: number;
  parameter: OriginVhostPHPConfigParameter;
  value: string;
}

export interface OriginVhostPHP {
  id: number;
  version: number;
  modules: OriginVhostPHPModule[];
  config: OriginVhostPHPConfig[];
  timestamp: Date;
}

export enum OriginVhostStatus {
  IN_PROGRESS,
  DONE,
  ERROR,
}

export const originVhostStatusStrings: Record<number, string> = {
  0: 'In Progress',
  1: 'Done',
  2: 'Error',
  3: 'Active',
  4: 'Disabled',
};

export interface OriginVhostLog {
  id: number;
  log: string;
}

export interface OriginVhost {
  id: number;
  websiteId: number;
  serverId: string;
  systemUserId: number;
  documentFolder: string;
  redirect: string;
  aliases: OriginVhostAlias[];
  php: OriginVhostPHP;
  status: OriginVhostStatus;
  logs: OriginVhostLog[];
}

export interface OriginVhostCreate {
  server: string;
  websiteId: number;
  systemUserId: number;
}

export interface OriginVhostUpdate {
  aliases: string[];
  php: {
    version: number;
  };
}

export interface OriginVhostConfigUpdate {
  modules: number[];
  configs: { parameter: number; value: string }[];
}

export interface OriginVhostRecord extends OriginVhost {
  server?: Server;
  website?: Website;
  systemUser?: SystemUser;
}

export interface OriginVhostEditDialogComponentData {
  vhost: OriginVhostRecord;
}

export interface OriginVhostEditReturnData {
  aliases: string[];
  phpVersion: string;
}
